/**
 * Meses do plano do Balanceamento: o que a seção "Meses do plano" (Cadastros) precisa.
 *
 * O mês do plano é o mês de PRODUÇÃO — do dia 16 do mês anterior ao dia 15. A janela vem
 * pronta do backend (`range`); aqui só mora o que é da tela.
 */

/** Disparado quando um mês é criado ou tem a data corrigida — o seletor de período recarrega. */
export const EVENTO_MESES_ALTERADOS = 'seop:meses-alterados';

export const MESES_DO_ANO = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

/** `2026-11-01` → `2026-11`. */
export const anoMes = (data: string): string => data.slice(0, 7);

/** O mês seguinte, para sugerir o próximo a adicionar. `2026-12` → `2027-01`. */
export function mesSeguinte(valor: string): string {
  const [ano, mes] = valor.split('-').map(Number);
  return mes === 12 ? `${ano + 1}-01` : `${ano}-${String(mes + 1).padStart(2, '0')}`;
}

/** Anos oferecidos no seletor: do ano anterior ao primeiro mês do plano até dois à frente do último. */
export function anosDisponiveis(datas: string[], anoAtual: number): number[] {
  const anos = datas.map((d) => Number(d.slice(0, 4))).filter(Number.isFinite);
  const inicio = Math.min(anoAtual, ...anos) - 1;
  const fim = Math.max(anoAtual, ...anos) + 2;
  return Array.from({ length: fim - inicio + 1 }, (_, i) => inicio + i);
}

/** A mensagem que o backend mandou no 400 (`{error: "invalid_month", message}`), se houver. */
export function mensagemDoMes(err: unknown): string | null {
  return (err as { response?: { data?: { message?: string } } })?.response?.data?.message ?? null;
}
